export default __webpack_public_path__ + "static/media/losAngelesChargersVideo-2x.b5f7617d.jpg";